'use client';

/* empty css                                     */
/* empty css                                        */
/* empty css                                     */
/* empty css                                      */
/* empty css                                      */
/* empty css                                       */
/* empty css                                        */
/* empty css                                         */
/* empty css                                      */
var toastNotificationsContainer = "c5-26-5_c6c8x61 c5-26-5_c6c8x60 c5-26-5_nly6ulw c5-26-5_nly6ul0 c5-26-5_nly6ul14 c5-26-5_161xunpj8 c5-26-5_nly6ul3v";
export {
  toastNotificationsContainer
};
